// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ol-0";
export var leftAlign = "_ol-4";
export var listItem = "_ol-2";
export var listItemWrapper = "_ol-1";
export var operationText = "_ol-3";